/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { useDispatch } from "react-redux";
import { AppDetailsPageEvent, useAppDetailsPageDataSelector } from ".";
import Modal from "react-bootstrap/Modal";

function BuildfileErrorModal() {
  const dispatch = useDispatch();
  const appdetailsPageData = useAppDetailsPageDataSelector();

  const hideBuildfileErrorModalAction = () => {
    dispatch({
      type: AppDetailsPageEvent.HIDE_BUILDFILE_ERROR_MODAL,
    });
  };

  return (
    <Modal
      show={appdetailsPageData.showBuildfileErrorModal}
      onHide={() => {
        hideBuildfileErrorModalAction();
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="sub-text">Error while downloading apk</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            hideBuildfileErrorModalAction();
          }}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default BuildfileErrorModal;
